import React from 'react';
import type {
  CmsContentProps,
  FaqsProps,
  StructuredColumnsProps,
  TwoColumnProps,
} from '@goodfynd/content';
import {
  CmsContent,
  Faqs,
  StructuredColumns,
  TwoColumn,
} from '@goodfynd/content';
import type { FooterProps } from '@goodfynd/layout';
import { Footer } from '@goodfynd/layout';
import { ButtonLink } from '@goodfynd/ui';

import type { ComponentProps, ComponentType } from './types';

export default function renderCmsBodyComponent(
  index: number,
  componentType: ComponentType,
  fields: any,
  { className, containerCSS }: ComponentProps = {}
): JSX.Element | null {
  switch (componentType) {
    case 'button':
      const { button_href, button_text, return_to_page } = fields as any;

      return !!button_href && !!button_text ? (
        <ButtonLink
          key={componentType + index}
          href={`${button_href}${
            return_to_page ? `?returnUrl=${window.location.href}` : ''
          }`}
        >
          {button_text}
        </ButtonLink>
      ) : null;

    case 'content_section':
      return (
        <CmsContent
          className={className}
          containerCSS={containerCSS}
          {...(fields as CmsContentProps)}
          key={componentType + index}
        />
      );

    case 'content_with_image_columns':
      return (
        <StructuredColumns
          {...(fields as StructuredColumnsProps)}
          key={componentType + index}
        />
      );

    case 'event_faqs':
      return <Faqs {...(fields as FaqsProps)} key={componentType + index} />;

    case 'footer':
      return (
        <Footer
          key={componentType + index}
          {...(fields.footers?.[0] as unknown as FooterProps)}
        />
      );

    case 'two_column_images':
      return (
        <TwoColumn
          {...(fields as TwoColumnProps)}
          key={componentType + index}
        />
      );

    case 'vendor_faqs':
      return <Faqs {...(fields as FaqsProps)} key={componentType + index} />;

    default:
      return null;
  }
}
